import React from "react";
import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function SoWhatPage() {
  return (
    <ProjectLayout
      title="So What, Now What?"
      role="Unity Developer — Face & Hand Tracking, Network Performance Tools"
      team="2"
      duration="Nov 2025"
      engine="Unity (C#)"
      about="A live theatre performance driven by real-time face and hand tracking, with a custom Unity toolset for scene setup and a networked pipeline for animating a glove character."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/gloveyFullFinal.mp4`}
      galleryImages={[
        `${process.env.PUBLIC_URL}/img/sowhat/1.png`,
        `${process.env.PUBLIC_URL}/img/sowhat/2.jpeg`,
        // `${process.env.PUBLIC_URL}/img/sowhat/3.mp4`,
      ]}
    >
      <section>
        <h2>About</h2>
        <p>
          <em>So What, Now What?</em> was a live theatre production that used real-time motion capture
          to drive an animated glove character — Glovey — entirely through the performer's face and hands.
          The system was designed to be operated live in performance conditions, with full networked
          communication between the performer's tracking rig and the rendering environment.
        </p>
        <p>
          The performance was based on the book{" "}
          <a href="https://www.amazon.com/So-What-Now-Being-Living/dp/176135230X" target="_blank" rel="noopener noreferrer">
            <em>So What, Now What?</em>
          </a>.
        </p>
        <p><em>Note: the performance was unfortunately postponed.</em></p>
      </section>

      <section>
        <h2>Scene Builder</h2>
        <p>
          A custom Unity editor toolset was developed for the production team to configure and manage
          scenes without needing to touch code. This included controls for camera switching, lighting
          rigs, and scene state — giving directors and operators a purpose-built UI for live performance use.
        </p>
      </section>

      <section>
        <h2>Face & Hand Tracking Pipeline</h2>
        <p>
          Real-time face and hand tracking data was captured from the performer and transmitted over
          the network to drive Glovey's animation rig. Facial expressions mapped to the character's
          features while hand pose data controlled movement and gesture — creating a puppeteering
          pipeline that required minimal latency and stayed stable under live performance conditions.
        </p>
      </section>

      {/* <section>
        <h2>Technical Details</h2>
        <p>
          [Placeholder — add specifics on tracking hardware, networking protocol, frame rate targets,
          team size, venue, and any notable technical challenges here.]
        </p>
      </section> */}
    </ProjectLayout>
  );
}
